import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

import Typography from "material-ui/Typography";
import Button from "material-ui/Button";

import DialogModal from "../../common/DialogModal";
import Trash from "../../Icons/Trash";

const styles = () => ({
  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
  },

  contentContainer: {
    padding: "25px",
    margin: 0,
  },

  container: {
    background: "#FFFFFF",
    border: "1px solid #D8DBDF",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "18px",
  },

  row: {
    padding: "15px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "center",
    boxSizing: "border-box",
  },

  innerRowLeft: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
  },

  iconBtn: {
    border: "1px solid #D8DBDF",
    marginLeft: "10px",
    fontSize: "15px",
    height: "38px",
    boxSizing: "border-box",
    minWidth: "unset",
    padding: 0,
  },

  button: {
    color: "#1A65FF",
    fontSize: "15px",
    fontWeight: "bold",
    width: "unset",
    height: "unset",
    minHeight: "unset",
    padding: 0,
    "&:hover": {
      textDecoration: "underline",
      backgroundColor: "none !important",
    },
  },

  buttonContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
  },
});

class EditMailsDialog extends React.Component {
  renderRow = (item, index, isLast = false) => {
    const { classes } = this.props;

    return (
      <div
        key={index}
        className={classes.row}
        style={{ borderBottom: isLast ? "none" : "1px solid #D8DBDF" }}
      >
        <div className={classes.innerRowLeft}>
          <Typography variant="subheading" style={{ fontWeight: "bold" }}>
            {item.name}
          </Typography>
          <Typography variant="body2">{item.email}</Typography>
        </div>
        <div className={classes.innerRowRight}>
          <Button
            className={classes.iconBtn}
            onClick={() => this.props.toggleConfirmDeleteMailDialog(item)}
            style={{ width: "38px" }}
          >
            <Trash height={16} width={16} color="#181819" />
          </Button>
          <Button
            className={classes.iconBtn}
            onClick={() => this.props.toggleEditMailDialog(item)}
            style={{ width: "70px" }}
          >
            編集
          </Button>
        </div>
      </div>
    );
  };

  render() {
    const { classes, toggleDialog, mails } = this.props;

    return (
      <DialogModal
        title="メールアドレスを編集"
        open={this.props.isOpen}
        onClose={toggleDialog}
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
      >
        <div className={classes.container}>
          {mails.map((mail, i) =>
            this.renderRow(mail, i, i === mails.length - 1)
          )}
        </div>
        <div className={classes.buttonContainer}>
          <Button
            color="primary"
            className={classes.button}
            onClick={this.props.toggleCreateMailDialog}
          >
            新規メールを登録
          </Button>
        </div>
      </DialogModal>
    );
  }
}

EditMailsDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  toggleCreateMailDialog: PropTypes.func.isRequired,
  toggleEditMailDialog: PropTypes.func.isRequired,
  toggleConfirmDeleteMailDialog: PropTypes.func.isRequired,
  mails: PropTypes.array.isRequired,
};

export default withStyles(styles)(EditMailsDialog);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Basic/EditMailsDialog.jsx